import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  setCookie(name: string, value: string, expires: Date, domain: string, path: string = '/') {
    if (!isPlatformBrowser(this.platformId)) return;
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; domain=${domain}; path=${path}`;
  }

  deleteCookie(name: string, domain: string, path: string = '/') {
    if (!isPlatformBrowser(this.platformId)) return;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=${path}`;
  }

  setCookieWithExpiryInDays(name: string, value: string, days: number, domain: string, path: string = '/') {
    if (!isPlatformBrowser(this.platformId)) return;
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    this.setCookie(name, value, date, domain, path);
  }

  getCookie(name: string): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  checkCookie(name: string): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    return this.getCookie(name) !== null;
  }
}
